import { isEmpty, isPlainObject } from 'lodash';

import { decodeJWT } from '../../../../shared/utils/jwt';

const websiteInterceptor = [
  (config) => {
    if (!config.includeWebsite) {
      return config;
    }

    try {
      const jwtPayload = decodeJWT();
      const websiteId = jwtPayload?.website_id;

      if (!websiteId) return config;

      if (config.method === 'get') {
        config.params = {
          ...config.params,
          website_id: websiteId,
        };
      }

      if (['patch', 'post', 'put'].includes(config.method)) {
        if (!isPlainObject(config.data) || isEmpty(config.data)) {
          return config;
        }

        // Extract the parent key / resource from the nested structure
        // (e.g., { appointment: {...} })
        const resource = Object.keys(config.data)[0];

        config.data = {
          [resource]: {
            ...config.data[resource],
            website_id: websiteId,
          },
        };
      }

      return config;
    } catch (error) {
      return config;
    }
  },
  (error) => Promise.reject(error),
  { synchronous: true },
];

export default websiteInterceptor;
